import React, { Component } from 'react'
import LessonCard from '../../components/LessonCard/LessonCard'
import { connect } from 'react-redux'
import { actions as CourseActions } from '../../modules/courses'
import { actions as ExamActions } from '../../modules/exam'
import { actions as RegisterActions } from '../../modules/application'
import { bindActionCreators } from 'redux'
import { Button, Card, notification, message, Modal, Radio, Form, Input } from 'antd'



const formItemLayout = {
    labelCol:{
        span: 5
    },
    wrapperCol:{
        span: 16,
    }
};
class HomePage extends Component {
    formRef = React.createRef()
    state = {
        visible: false,
        evalution_ID: 0,
        startingExam: false,
        evalution_course: ""
    }

    componentDidMount() {
        this.props.actions.getCourseList({ username: this.props.application.username })
        this.props.actions.getLessonList({ username: this.props.application.username })
        this.props.examActions.getRealExamList({ username: this.props.application.username })
    }

    componentWillReceiveProps = nextProps => {
        if (nextProps.application.userInfo && this.props.application.userInfo !== nextProps.application.userInfo && nextProps.application.userInfo.newMessage > 0) {
            notification.info({
                message: `你有${nextProps.application.userInfo.newMessage}条新信息`,
                placement: 'topRight',
                duration: 5
            })
        }
        if (nextProps.application.userInfo && this.props.application.userInfo !== nextProps.application.userInfo && nextProps.application.userInfo.newEvalution > '') {
            let ar = nextProps.application.userInfo.newEvalution.split("|");
            this.setState({ visible: true, evalution_ID: ar[0], evalution_course: ar[1] })
        }
    }


    onClickExam = paperID => {
        if (this.state.startingExam) {
            return
        }
        this.setState({ startingExam: true }, () => {
            this.props.examActions.updateLeave(false)
            this.props.examActions.getExam({ paperID })
        })
    }

    componentDidUpdate = prevProps => {
        if (
            this.state.startingExam &&
            this.props.exam.exam &&
            prevProps.exam.exam !== this.props.exam.exam
        ) {
            const exam = this.props.exam.exam[0]
            if (exam.missingItems) {
                message.info('请填写' + exam.missingItems)
                this.props.history.push('/userinfo')
            } else if (exam.startExamMsg !== '') {
                message.info(exam.startExamMsg)
            } else if (exam.allowMockMsg !== '') {
                message.info(exam.allowMockMsg)
            } else {
                this.props.examActions.getExamQuestion({
                    paperID: exam.paperID,
                    pkind: exam.pkind,
                    examID: exam.examID,
                    kind: 0,
                    page: 1,
                    pageSize: 20,
                    onlyWrong: 1,
                    s: 0
                })
                this.props.history.push('/exampage')
            }
            this.setState({ startingExam: false })
        }
    }

    onClickRule = () => {
        Modal.info({
            title: '考生须知',
            content: (
                <div>
                    <p>1、仔细检查题目，交卷后将无法进入。</p>
                    <p>2、迟到15分钟不得入场。</p>
                </div>
            ),
            onOk() { },
        });
    }

    handleOk = values => {
        let params = {
            ID: this.state.evalution_ID,
            enterID: 0,
            F1: values.F1,
            F2: values.F2,
            F3: values.F3,
            F4: values.F4,
            F5: values.F5,
            F6: values.F6,
            F7: values.F7,
            memo: values.memo || "",
            registerID: ""
        };
        // console.log("updateEvalutionFormInfo:", params)
        this.props.registerActions.postEvalution({proc:"updateEvalutionFormInfo", params:params});
        notification.info({
            message: `提交成功，谢谢配合。`,
            placement: 'topRight',
            duration: 5
        })
        this.setState({
          visible: false,
        });
    };
    
    handleCancel = e => {
        this.setState({
          visible: false,
        });
    };

    render() {
        const { courses, lessons } = this.props.course
        const { actions, examActions, exam } = this.props
        const { TextArea } = Input;
        if (courses.length === 0) {
            return <div>
                <h3>还未选择课程</h3>
            </div>
        }
        return (
            <div>
                <div>
                    {this.props.exam.realExamList && this.props.exam.realExamList.length > 0 ? <Card title="我的考试">
                        {this.props.exam.realExamList.map(exam => (
                            <Card.Grid style={{ width: '100%', textAlign: 'left', background: '#BBFFFF' }}>
                                <p>科目：{exam.certName}</p>
                                <p>日期：{exam.startDate}</p>
                                <p>地点：{exam.address}</p>
                                <p>姓名：{exam.name} &nbsp;&nbsp;类型：{exam.kindName}</p>
                                <Button type="primary" onClick={this.onClickRule}>考生须知</Button>&nbsp;&nbsp;
                                {exam.kindID === 1 ? (exam.status < 2 ? <Button type="primary" onClick={() => this.onClickExam(exam.paperID)}>开始考试</Button> : <span>已完成</span>) : null}
                            </Card.Grid>
                        ))}
                    </Card> : null}
                </div>
                <div>
                    {courses.map(course => (
                        <LessonCard application={this.props.application} exam={exam} key={course.ID} course={course} courseState={this.props.course} lessons={lessons} actions={actions} examActions={examActions} />
                    ))}
                </div>
                <div>
                    <Modal
                    title={"学员评议表：" + this.state.evalution_course}
                    visible={this.state.visible}
                    // onOk={this.handleOk}
                    // onCancel={this.handleCancel}
                    // okText="提交"
                    // cancelText="取消"
                    closable = {false}
                    footer={[]}
                    >
                    <Form
                        {...formItemLayout}
                        onFinish={this.handleOk}
                        initialValues={{ F1:'0', F2:'0', F3:'0', F4:'0', F5:'0', F6:'0', F7:'0' }}
                        scrollToFirstError
                        ref={this.formRef}
                    >
                        <Form.Item
                            name="F1"
                            label="教学态度："
                            style={{ marginTop: '1px', marginBottom: '1px' }}
                        >
                            <Radio.Group>
                                <Radio value="0">好</Radio>
                                <Radio value="1">较好</Radio>
                                <Radio value="2">尚可</Radio>
                                <Radio value="3">差</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            name="F2"
                            label="教学内容："
                            style={{ marginTop: '1px', marginBottom: '1px' }}
                        >
                            <Radio.Group>
                                <Radio value="0">好</Radio>
                                <Radio value="1">较好</Radio>
                                <Radio value="2">尚可</Radio>
                                <Radio value="3">差</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            name="F3"
                            label="教学方法："
                            style={{ marginTop: '1px', marginBottom: '1px' }}
                        >
                            <Radio.Group>
                                <Radio value="0">好</Radio>
                                <Radio value="1">较好</Radio>
                                <Radio value="2">尚可</Radio>
                                <Radio value="3">差</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            name="F4"
                            label="教学手段："
                            style={{ marginTop: '1px', marginBottom: '1px' }}
                        >
                            <Radio.Group>
                                <Radio value="0">好</Radio>
                                <Radio value="1">较好</Radio>
                                <Radio value="2">尚可</Radio>
                                <Radio value="3">差</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            name="F5"
                            label="讲解示范："
                            style={{ marginTop: '1px', marginBottom: '1px' }}
                        >
                            <Radio.Group>
                                <Radio value="0">好</Radio>
                                <Radio value="1">较好</Radio>
                                <Radio value="2">尚可</Radio>
                                <Radio value="3">差</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            name="F6"
                            label="巡回指导："
                            style={{ marginTop: '1px', marginBottom: '1px' }}
                        >
                            <Radio.Group>
                                <Radio value="0">好</Radio>
                                <Radio value="1">较好</Radio>
                                <Radio value="2">尚可</Radio>
                                <Radio value="3">差</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            name="F7"
                            label="课时完成："
                            style={{ marginTop: '1px', marginBottom: '1px' }}
                        >
                            <Radio.Group>
                                <Radio value="0">好</Radio>
                                <Radio value="1">较好</Radio>
                                <Radio value="2">尚可</Radio>
                                <Radio value="3">差</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            name="memo"
                            label="意见与建议："
                            style={{ marginTop: '1px', marginBottom: '5px' }}
                        >
                            <TextArea rows={3} placeholder="感谢您的支持" />
                        </Form.Item>
                        <Form.Item
                            wrapperCol={{ span: 10, offset: 10 }}
                            style={{ marginTop: '5px', marginBottom: '0px' }}
                        >
                            <Button type="primary" htmlType="submit">提交</Button>
                        </Form.Item>
                    </Form>
                    </Modal>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    course: state.course,
    application: state.application,
    exam: state.exam
})


const mapDispatchToProps = dispatch => ({
    registerActions: bindActionCreators(RegisterActions, dispatch),
    actions: bindActionCreators(CourseActions, dispatch),
    examActions: bindActionCreators(ExamActions, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);



// WEBPACK FOOTER //
// src/containers/HomePage/HomePage.jsx